import {
  GET_CLUB_MEMBERSHIP_REQUEST,
  LIST_CLUB_MEMBERSHIPS_REQUEST,
  EDIT_CLUB_MEMBERSHIP_REQUEST,
  CANCEL_CLUB_MEMBERSHIP_REQUEST,
  ADD_CLUB_MEMBERSHIP_HOLD_REQUEST,
  EDIT_CLUB_MEMBERSHIP_HOLD_REQUEST,
  RESET_CLUB_MEMBERSHIP_QUERY,
  DELETE_CLUB_MEMBERSHIP_HOLD_REQUEST
} from './constants';

export const listClubMemberships = (queryString) => ({
  type: LIST_CLUB_MEMBERSHIPS_REQUEST,
  queryString
});

export const getClubMembership = (clubMembershipId) => ({
  type: GET_CLUB_MEMBERSHIP_REQUEST,
  clubMembershipId
});

export const editClubMembership = (
  clubMembershipId,
  clubMembership,
  successFunction
) => ({
  type: EDIT_CLUB_MEMBERSHIP_REQUEST,
  clubMembershipId,
  clubMembership,
  successFunction
});

export const cancelClubMembership = (
  clubMembershipId,
  clubMembership,
  successFunction
) => ({
  type: CANCEL_CLUB_MEMBERSHIP_REQUEST,
  clubMembershipId,
  clubMembership,
  successFunction
});

export const addHold = (clubMembershipId, onHold, successFunction) => ({
  type: ADD_CLUB_MEMBERSHIP_HOLD_REQUEST,
  clubMembershipId,
  onHold,
  successFunction
});

export const editHold = (clubMembershipId, id, onHold, successFunction) => ({
  type: EDIT_CLUB_MEMBERSHIP_HOLD_REQUEST,
  clubMembershipId,
  id,
  onHold,
  successFunction
});

export const deleteHold = (clubMembershipId, id, successFunction) => ({
  type: DELETE_CLUB_MEMBERSHIP_HOLD_REQUEST,
  clubMembershipId,
  id,
  successFunction
});

export const resetClubMembershipQuery = () => ({
  type: RESET_CLUB_MEMBERSHIP_QUERY
});
